// ===================================================
// ФАЙЛ: frontend/src/pages/Auth/ResetPassword.jsx
// Сброс пароля перенесён в Маркбэйс id (auth.markbase.ru).
// Эта страница только перенаправляет пользователя в единый центр аутентификации.
// ===================================================
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';

const getUamUrl = () => {
  const raw = process.env.REACT_APP_UAM_URL || 'https://auth.markbase.ru';
  return raw.replace(/\/+$/, '');
};

const ResetPassword = () => {
  const [params] = useSearchParams();

  useEffect(() => {
    const returnUrl = `${window.location.origin}/login`;
    const email = params.get('email') || '';
    const query = new URLSearchParams({ return_url: returnUrl });
    if (email) query.set('email', email);
    window.location.replace(`${getUamUrl()}/reset-password?${query.toString()}`);
  }, [params]);

  return (
    <main style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24 }}>
      <Spin size="large" />
      <div style={{ color: '#666' }}>Переход в центр восстановления пароля…</div>
    </main>
  );
};

export default ResetPassword;
